<h2 _ngcontent-c33="" class="group-title">{{config?.label}}</h2>
